import o from "./index154.js";
/* empty css         */
import t from "./index130.js";
const f = /* @__PURE__ */ t(o, [["__scopeId", "data-v-42f3005e"]]);
export {
  f as default
};
